import { Component, OnInit, Inject } from '@angular/core';
import { RequestPayLoadFormat, CommonServiceLayerService } from './services/common-service-layer.service';
import { AppService } from './app.service';
import { AlertService } from './shared/alert.service';
import { SharedService } from './shared/shared.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  constructor(
    public http: CommonServiceLayerService,
    public appService: AppService,
    public alert: AlertService,
    public sharedService: SharedService) { }
  public errorType;
  public showUI = false;
  public errorMessages = {
    constants: 'Failed to fetch constants please contact admnin',
    domain: 'Failed to fetch domain mapping please contact admin'
  };
  ngOnInit() {
    this.fetchDomainDetails();
  }
  fetchDomainDetails() {
    const payLoad = {};
    try {
      this.appService.setDomainMapping(environment.settings);
      this.fetchConstants();
    } catch (error) {
      this.sharedService.internalCodeError(error);
      this.errorType = 'domain';
    }
  }
  fetchConstants() {
    const payLoad = {};
    try {
      const request: RequestPayLoadFormat = {
        api: 'constants',
        method: 'get',
        loader: true,
        type: 'JSON',
        hideErrorMessage: false,
        payLoad,
        disableTokenValidation: true
      };
      this.http.API_REQUEST(request).subscribe(response => {
        if (response.status) {
          this.appService.setConstants(response.data);
          this.showUI = true;
        } else {
          this.alert.open('error', response.message, 'try again');
          this.errorType = 'constants';
        }
      });
    } catch (error) {
      this.sharedService.internalCodeError(error);
      this.errorType = 'constants';
    }
  }
  retry() {
    if (this.errorType === 'domain') {
      this.fetchDomainDetails();
    } else {
      this.fetchConstants();
    }
  }
}
